export default {
  dashboardData: {},
  studyId: "",
  sitesData: [],
  benchMarkData: {},
  enrollmentData: {},
  eConsentUploadedData: {},
  topScreenFailuaresReason: {},
  quizData: {},
  recruitmentData: {},
  sensorComplianceData: {},
  overallCollectionData: {},
  cacelledTelehealthVisits: {},
  complianceInsightScore: {},
  overallCollectionMissingData: {},
  nonCompliantActivities: {},
  telehealthVisitsDuration: {},
  complianceRateOverTime: {},
  studyComplianceData: "",
  studyParticipantComplianceData: "",
  overallCollectionParticipantData: {},
  graphicComplianceData: {},
  analyticsUsersData: {},
  dashboardRefreshData: "",
  siteById: {},
  allEnrollmentData: {},
  participantProgressData: {},
  discontinuationActivity: {},
  otherDiscontinuationReasons: {},
  participantStudyProgression:{},
  milestonesData:{},
  selectedSiteId:""
};
